import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import {z} from 'zod';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';

export default function finalizeConditionTool() {
  async function execute() {
    const card = getCardFromState();

    // Find existing fallback output
    const fallbackIndex = card.outputs.findIndex((output) => output.type === OutputType.Fallback);

    if (fallbackIndex !== -1) {
      // Move existing fallback to the end
      const [fallbackOutput] = card.outputs.splice(fallbackIndex, 1);
      card.outputs.push(fallbackOutput);
    } else {
      // Add new fallback at the end
      card.outputs.push({
        id: card.outputs.length + 1,
        nodeId: NO_NODE_ID,
        name: 'Fallback',
        type: OutputType.Fallback,
      });
    }

    setCardInState(card);

    return toolResult('Condition finalized successfully');
  }

  return tool({
    name: V2CardAgentToolName.FinalizeCondition,
    displayName: 'Finalizing condition card',
    description: 'Finalize the condition card, implement custom card related logic',
    inputSchema: z.object({}),
    execute,
  });
}
